import React from 'react';

export default function Carousel() {
    return (
        <div id="caro" className="carousel-container">
            <div className="grid-center-noGutter content-maxWidth">
                <div className="col-7_xs-11_md-7">
                    <h2>BETTER HEALTH</h2>
                    <h2>THROUGH</h2>
                    <h2 className="highlight">INTEGRATIVE CARE</h2>
                    <div className="mission">Our mission at Pursuit Integrative Health is to serve our community’s healthcare needs, as well as guide our patients toward the achievement of optimal health.</div>
                    <a href="/about-us">More About Us</a>
                </div>
                <div className="col-4_xs-11_md-4 ig-image">
                    <a
                        href="https://www.instagram.com/pursuit_health/"
                        target="_blank"
                    >
                        <img src="/img/IG_stayConnected.jpg" />
                        <div className="follow-text">
                            Stay connected, follow us on Instagram for updates.
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
};
